// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Admin/AdminLogin.css */

.admin-login-container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0f172a; /* Dark navy background */
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.login-box {
    background: #ffffff;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
}

.login-header {
    text-align: center;
    margin-bottom: 30px;
}

.login-header h2 {
    color: #1e293b;
    font-size: 1.8rem;
    margin-bottom: 8px;
}

.login-header p {
    color: #64748b;
    font-size: 0.9rem;
}

.input-group {
    margin-bottom: 20px;
}

.input-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #334155;
}

.input-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 1rem;
    transition: border-color 0.2s;
}

.input-group input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

button {
    width: 100%;
    padding: 12px;
    background: #2563eb;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

button:hover {
    background: #1d4ed8;
}

button:disabled {
    background: #94a3b8;
    cursor: not-allowed;
}

.error-msg {
    color: #ef4444;
    font-size: 0.85rem;
    margin-bottom: 15px;
    text-align: center;
    background: #fee2e2;
    padding: 8px;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/AdminLogin.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB,EAAE,yBAAyB;IAC9C,4DAA4D;AAChE;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["/* src/components/Admin/AdminLogin.css */\n\n.admin-login-container {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #0f172a; /* Dark navy background */\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.login-box {\n    background: #ffffff;\n    padding: 40px;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n    width: 100%;\n    max-width: 400px;\n}\n\n.login-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.login-header h2 {\n    color: #1e293b;\n    font-size: 1.8rem;\n    margin-bottom: 8px;\n}\n\n.login-header p {\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n.input-group {\n    margin-bottom: 20px;\n}\n\n.input-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #334155;\n}\n\n.input-group input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    font-size: 1rem;\n    transition: border-color 0.2s;\n}\n\n.input-group input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\nbutton {\n    width: 100%;\n    padding: 12px;\n    background: #2563eb;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\nbutton:hover {\n    background: #1d4ed8;\n}\n\nbutton:disabled {\n    background: #94a3b8;\n    cursor: not-allowed;\n}\n\n.error-msg {\n    color: #ef4444;\n    font-size: 0.85rem;\n    margin-bottom: 15px;\n    text-align: center;\n    background: #fee2e2;\n    padding: 8px;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
